import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './StatusIndicator.scss';

interface Props {
  status: boolean;
}

const StatusIndicator: FC<Props> = ({ status }) => {
  const { t } = useTranslation();

  const renderStatusIndicator = cssClasses => {
    return <div className={cssClasses}>{t(status ? 'lblActive' : 'lblInactive')}</div>;
  };
  return renderStatusIndicator(`status-indicator status-indicator-${status}`);
};

export default StatusIndicator;
